import { render, staticRenderFns } from "./SiteTables.vue?vue&type=template&id=c312b724&"
import script from "./SiteTables.vue?vue&type=script&lang=js&"
export * from "./SiteTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports